export default __webpack_public_path__ + "static/media/Logo_simple.3ac4977e.svg";